import React from "react";
import "../style/noFound.css";
function Nofoundpage() {return <div id="container-noFound">404 No Found</div>;}
export default Nofoundpage;
